import { rootUrl } from '../const';
import { downloadExcelForIndemnity } from './downloadExcelForIndemnity';

export const GuestVisitAPI = {
	downloadExcelForIndemnity: downloadExcelForIndemnity(rootUrl),
};
